import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import './TopInfluencers.css';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const TopInfluencers = () => {
  const influencerData = [
    { name: 'Zendaya', engagement: 3913052, posts: 2 },
    { name: 'Beyoncé', engagement: 1989734, posts: 2 },
    { name: 'Charli', engagement: 1538562, posts: 4 },
    { name: 'Lily Collins', engagement: 1414789, posts: 9 },
    { name: 'Jackson Wang', engagement: 1015827, posts: 2 },
    { name: 'Chloë Grace Moretz', engagement: 950123, posts: 8 },
    { name: 'Ashley Benson', engagement: 847291, posts: 2 },
    { name: 'Calvin Klein', engagement: 691234, posts: 1 },
    { name: 'The Walking Dead', engagement: 556780, posts: 1 },
    { name: 'Gwyneth Paltrow', engagement: 498234, posts: 12 }
  ];

  const data = {
    labels: influencerData.map(d => d.name),
    datasets: [{
      label: 'Total Engagement',
      data: influencerData.map(d => d.engagement),
      backgroundColor: influencerData.map((_, i) => {
        const opacity = 1 - (i * 0.07);
        return `rgba(195, 255, 0, ${opacity})`;
      }),
      borderColor: 'rgba(195, 255, 0, 1)',
      borderWidth: 1,
      borderRadius: 8
    }]
  };

  const options = {
    indexAxis: 'y',
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: true,
        text: 'Top 10 Celebrity Investment Influencers',
        color: '#C3FF00',
        font: {
          size: 18,
          weight: 'bold'
        },
        padding: {
          bottom: 20
        }
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const celeb = influencerData[context.dataIndex];
            return [
              `Engagement: ${celeb.engagement.toLocaleString()}`,
              `Posts: ${celeb.posts}`
            ];
          }
        }
      }
    },
    scales: {
      x: {
        grid: {
          color: 'rgba(255, 255, 255, 0.1)'
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.8)',
          callback: function(value) {
            return (value / 1000000).toFixed(1) + 'M';
          }
        }
      },
      y: {
        grid: {
          display: false
        },
        ticks: {
          color: 'rgba(255, 255, 255, 0.8)',
          font: {
            size: 12
          }
        }
      }
    }
  };

  return (
    <div className="top-influencers glass-card">
      <div className="chart-container">
        <Bar data={data} options={options} />
      </div>
      <div className="influencer-insights">
        <p className="insight-text">
          <span className="highlight">Zendaya</span> leads with <span className="highlight">3.9M+</span> engagements
        </p>
        <p className="insight-text">
          Perfect ambassadors for Squad.app's celebrity-backed investments
        </p>
      </div>
    </div>
  );
};

export default TopInfluencers;